import { takeLatest, put } from 'redux-saga/effects';

import {
  animalLoteCadastro,
  NEW_ANIMAL_LOTE_CADASTRO,
  NEW_ANIMAL_LOTE_CADASTRO_SUCCESS,
} from '@handler';

function* sagaNewAnimalLoteCadastro(action) {

  yield put({ 
    type: NEW_ANIMAL_LOTE_CADASTRO_SUCCESS, 
    registro: animalLoteCadastro.newRegistro,
    isCadastroRapido: action.isCadastroRapido, 
  });
}

export default function* watchNewAnimalLoteCadastro() {
  yield takeLatest(NEW_ANIMAL_LOTE_CADASTRO, sagaNewAnimalLoteCadastro)
}
